class LazyVideo extends HTMLElement {
  constructor() {
    super();

    this.template = null;
    this.observer = null;
  }

  connectedCallback() {
    if (this.hasAttribute("loaded")) return;

    this.template = this.querySelector(":scope > template");

    if (!this.template) return;

    if (!("IntersectionObserver" in window)) {
      this.load();
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        if (
          entries.some(
            (entry) => entry.isIntersecting && entry.intersectionRatio >= 0.1,
          )
        ) {
          this.load();
        }
      },
      { threshold: 0.1 },
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  load() {
    if (!this.template || this.hasAttribute("loaded")) return;

    this.append(this.template.content.cloneNode(true));
    this.template.remove();
    this.template = null;
    this.setAttribute("loaded", "");
    this.observer?.disconnect();
    this.observer = null;

    this.dispatchEvent(
      new CustomEvent("lazy-video-loaded", {
        bubbles: true,
        composed: true,
        detail: {
          target: this,
          section: this.closest('[id^="shopify-section-"]'),
        },
      }),
    );
  }
}

if (!customElements.get("lazy-video")) {
  customElements.define("lazy-video", LazyVideo);
}
